module.exports = __webpack_public_path__ + "static/nib-italic-pro-ff02b47f879d26941bc5ab12d9e2ba57.woff2";